
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation } from "vuex-class"

import { get } from "lodash"

import vSelect from "vue-select"

import SkeletonLoader from "@/components/SkeletonLoader.vue"
import { formatFieldsMixin } from "@/mixins/formatFieldsMixin"

import api from "@/services/api"
import { DataDefinition, FieldInstance } from "../../types"

const caseStore = namespace("cases")
const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect,
		"skeleton": SkeletonLoader
	}
})
export default class DataSourceTemplateSelect extends Vue {
	$refs!: {
		textarea: any;
	}

	@caseStore.Mutation
	public setCaseFieldDetails!: (details: any) => void;

	@setup.Getter("getDefinitionsById")
	definitionsById: any;

	@Prop({ type: Array })
	public value!: any[];

	@Prop({ type: String, default: "" })
	public placeholder!: string;

	@Prop({ type: Boolean, default: false })
	public readonly!: boolean;

	@Prop({ type: String, default: "" })
	public dataSourceId!: string;

	@Prop({ type: String, default: "" })
	public definitionId!: string;

	@Prop({ type: String, default: "" })
	public fieldId!: string;

	@Prop({ type: String, default: "" })
	public dataSourceTitle!: string;

	public dataSourceOptions: any[] = [];

	public addingItem: any = [];
	// public selectedItems: any = [];

	public dataSource: any = null;
	public definition: DataDefinition | null = null;

	public async mounted () {
		if (this.dataSourceId) {
			this.dataSource = await api.dataSourceGet(this.dataSourceId)
		}

		if (this.definitionId && (!this.dataSource || this.dataSource.definitionId !== this.definitionId)) {
			this.definition = await api.definitionDetails(this.definitionId)
		} else if (this.dataSource.definition) {
			this.definition = this.dataSource.definition
		} else if (this.dataSource && this.dataSource.definitionId) {
			this.definition = await api.definitionDetails(this.dataSource.definitionId)
		}
	}

	public get selectedItems () {
		if (!this.value) {
			return []
		}

		return this.value
	}

	public get dataSourceFields (): any[] {
		if (!this.definition) {
			return [
				{
					key: "label"
				}
			]
		}

		this.definition.fields!.forEach((field: FieldInstance) => {
			if (this.definition!.sections) {
				const sectionOrder = this.definition!.sections.indexOf(field.section)
				field.sectionOrder = sectionOrder === -1 ? 99999 : sectionOrder
			}
		})

		return [
			...this.definition.fields!.filter((f: FieldInstance) => f.includeInTable)
				.sortByThen({ key: "sectionOrder" }, { thenKey: "order" })
				.map((f: FieldInstance) => {
					return {
						key: "fields." + f.field.id,
						label: f.field.title,
						extensions: f.field.extensions,
						sortable: true
					}
				}),
			{
				key: "buttons",
				label: ""
			}
		]
	}

	public addNewItem (): void {
		this.$emit("openNewItemModal", {
			source: this.dataSource,
			definition: this.definition,
			addNewItem: true,
			addItem: (dataItem: any) => {
				this.$emit("add", dataItem)
			}
		})
	}

	public removeItem (item: any): void {
		this.$emit("remove", item)
	}

	public selectItem (item: any): void {
		this.$emit("openNewItemModal", {
			source: this.dataSource,
			definition: this.definition,
			addNewItem: true,
			data: item,
			readonly: this.readonly,
			updateItem: (dataItem: any) => {
				this.$emit("update", dataItem)
			}
		})
	}

	public fieldValue (item: any, fieldKey: string) {
		let itemLabel = get(item, fieldKey + "-label")
		if (itemLabel) return itemLabel

		const itemValue = get(item, fieldKey)

		if (Array.isArray(itemValue)) {
			return itemValue.map(i => i.label).join(", ")
		}

		if (!this.definition) return itemValue
		const field = this.definition!.fields!.find(f => "fields." + f.field.id === fieldKey)
		if (!field) return itemValue

		return formatFieldsMixin.methods.formatFieldValue(field!.field!.dataType!, itemValue)
	}
}
